"use strict";

exports.__esModule = true;
exports.default = void 0;
var _ListCache = _interopRequireDefault(require("./_ListCache.js"));
var _stackClear = _interopRequireDefault(require("./_stackClear.js"));
var _stackDelete = _interopRequireDefault(require("./_stackDelete.js"));
var _stackGet = _interopRequireDefault(require("./_stackGet.js"));
var _stackHas = _interopRequireDefault(require("./_stackHas.js"));
var _stackSet = _interopRequireDefault(require("./_stackSet.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new _ListCache.default(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = _stackClear.default;
Stack.prototype['delete'] = _stackDelete.default;
Stack.prototype.get = _stackGet.default;
Stack.prototype.has = _stackHas.default;
Stack.prototype.set = _stackSet.default;
var _default = exports.default = Stack;